<template>
    <b-modal :id="'modal-atualizar-descricao-arquivo-primeseg'" hide-footer centered title="Atualizar Descrição Arquivo">
        <div>
            <label for="descricao">Descrição:</label>
            <b-textarea id="descricao" v-model="descricao"></b-textarea>
        </div>
        <div class="d-flex mt-5">
            <b-button variant="outline-success" class="mx-auto" :disabled="carregando" @click="atualizarDescricao">
                <b-spinner class="align-middle" variant="success" v-show="carregando"></b-spinner>
					<span v-show="!carregando">
						Atualizar
					</span>
            </b-button>
        </div>

    </b-modal>
</template>

<script>
import ArquivoPrimesegService from "../../service/ArquivoPrimesegService.js";

export default {
	name: "ModalAtualizarDescricaoArquivoUsuario",
	data() {
		return {
			carregando: false,
			arquivo: "",
			descricao: "",
		};
	},
	methods: {
		abrirModal(arquivo) {
			this.arquivo = arquivo;
			this.descricao = arquivo.descricao;
			this.$bvModal.show("modal-atualizar-descricao-arquivo-primeseg");
		},
		atualizarDescricao() {
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));

			this.carregando = true;
			ArquivoPrimesegService.atualizar(this.arquivo.id, this.descricao, usuarioLogado.id)
				.then(() => {
					this.mensagem("Descrição Atualizada Com Sucesso!", "Sucesso", "success");
					this.$bvModal.hide("modal-atualizar-descricao-arquivo-primeseg");
				})
				.then(() => {
					this.$emit("input");
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível realizar essa operação nesse momento. Por", "Erro", "danger");
					}
				})
				.finally(() => {
					this.carregando = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/GerenciarArquivosPrimeseg/ModalAtualizarDescricaoArquivoPrimeseg.vue